export class FolderReqVm {
    UserID: string;
    DatabaseID: number;
    OrganizationID: number;
    transactionID: number;
    officeID:number=0;
    OfficeIDList: any;
}
